module.exports = __webpack_public_path__ + "static/media/libro7.6a51f9b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro7.png
// module id = 355
// module chunks = 0